import FormatCurrency from 'components/Common/FormatCurrency'
import Caption from 'LuxKit/Typography/Caption'
import type { ComponentProps } from 'react'
import { useIntl } from 'react-intl'

type InheritedFormatCurrencyProps = Pick<ComponentProps<typeof FormatCurrency>, 'signDisplay'>

interface Props extends InheritedFormatCurrencyProps {
  nonMemberPrice: number
  className?: string
  /** Amount emphasis; defaults to the existing bold non-member price. */
  priceWeight?: ComponentProps<typeof Caption>['weight']
}

/**
 * Displays price for non-members with a proper caption.
 */
function PriceRowLuxPlusNonMemberPrice(props: Props) {
  const {
    nonMemberPrice,
    signDisplay,
    className,
    priceWeight = 'bold',
  } = props
  const intl = useIntl()
  const price = <FormatCurrency signDisplay={signDisplay} value={nonMemberPrice} format="roundedDollar" />

  return <Caption
    variant="medium"
    colour="light-foreground-alt"
    className={className}
  >
    {intl.formatMessage(
      {
        id: 'kDkl7bT4Gb-QmQ300neV',
        defaultMessage: 'Non-member {price}',
        description: 'Price caption label for non-member price display in the LuxPlus membership section',
      },
      {
        price: priceWeight === 'bold' ?
            <b>{price}</b> :
            <Caption as="span" variant="medium" colour="inherit" weight={priceWeight}>
              {price}
            </Caption>,
      },
    )}
  </Caption>
}

export default PriceRowLuxPlusNonMemberPrice
